import React, { useEffect, useRef, useState } from "react";
import { Menu, MenuItem, MenuButton, SubMenu } from "@szhsin/react-menu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";

const LocationMenu = () => {
  const [chevronState, setChevronState] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const handleChevronClick = () => {
    setChevronState((prevState) => !prevState);
  };

  useEffect(() => {
    const handleOutsideClick = (event: { target: any }) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setChevronState(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={menuRef} style={{ cursor: "pointer" }}>
      <Menu
        menuButton={
          <div onClick={handleChevronClick}>
            Location{" "}
            {chevronState ? (
              <IoIosArrowUp size={24} />
            ) : (
              <IoIosArrowDown size={24} />
            )}
          </div>
        }
      >
        <SubMenu label="Hyderabad">
          <MenuItem style={{textDecoration:"none",color:"black"}} target="_blank"href="https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-jubilee%20hills">Jubilee Hills</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-miyapur">Miyapur</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-suchitra%20circle">Suchitra x Road</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-hyderabad/private-celebration-venue-in-himayatnagar">Himayatnagar</MenuItem>
        </SubMenu>
        <SubMenu label="Bengaluru">
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-koramangala">Koramangala</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-rajaji%20nagar">Rajaji Nagar</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-banashankari">Banashankari</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-whitefield">Whitefield</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}}target="_blank" href="https://thebingetown.com/private-theatres-in-bangalore/private-celebration-venue-in-nagavara">Nagavara</MenuItem>
        </SubMenu>
        <SubMenu label="Delhi">
          <MenuItem  style={{textDecoration:"none",color:"black"}} target="_blank" href="https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-janakpuri">Janakpuri</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}} target="_blank" href="https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-laxmi%20nagar">Laxmi Nagar</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}} target="_blank" href="https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-saket">Saket</MenuItem>
          <MenuItem  style={{textDecoration:"none",color:"black"}} target="_blank" href="https://thebingetown.com/private-theatres-in-delhi/private-celebration-venue-in-karol%20bagh">Karol Bagh</MenuItem>
        </SubMenu>
      </Menu>
    </div>
  );
};

export default LocationMenu;
